let originalParent = null;
let originalIndex = null;

function moveFeatures() {
  const $parent = $('.key_features_content');
  const $left = $parent.find('.left');

  if (!$left.length) return;

  // capture original state once
  if (originalParent === null) {
    originalParent = $left.parent();
    originalIndex = $left.index();
  }

  if (window.innerWidth <= 767) {
    // move to end if not already
    if ($left.index() !== $parent.children().length - 1) {
      $left.appendTo($parent);
    }
  } else {
    // restore to original location if changed
    if ($left.parent()[0] !== originalParent[0] || $left.index() !== originalIndex) {
      if (originalIndex >= originalParent.children().length) {
        $left.appendTo(originalParent);
      } else {
        $left.insertBefore(originalParent.children().eq(originalIndex));
      }
    }
  }
}

$(document).ready(moveFeatures);
$(window).on('resize', moveFeatures);
